// import { Button, Row, Col, Tooltip } from "antd"; // Added Tooltip
// import DispatchCheckerService from "../../../services/Dispatch-Checker/DispatchCheckerService";
// import ResponseMessage from "../../Comman/Notification/ResponseMessge";
// import { useState } from "react";

// const ReviewButton = ({
//   prototypeForm,
//   modalData,
//   onAction,
//   hasSaved,
//   isFormComplete,
//   imageType,
//   displayedDataList,
//   refreshCounts,
//   isLineItemSelected,
//   isPartFilled,
//   isFormFullyComplete,
// }) => {
//   const [isPassProcessing, setIsPassProcessing] = useState(false);

//   const styles = {
//     button: {
//       width: "100%",
//       fontWeight: "bold",
//       color: "white",
//       height: "80px",
//       lineHeight: "80px",
//       fontSize: "30px",
//       padding: "10px",
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "center",
//       boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//       position: "relative",
//       zIndex: 1,
//     },
//     text: { marginLeft: "25px" },
//     emoji: { marginRight: "30px" },
//     container: { position: "relative", zIndex: 1 },
//   };

//   const userData = JSON.parse(localStorage.getItem('userData'));

//   const handleClickPass = async () => {
//     setIsPassProcessing(true);
//     try {
//       console.log(modalData, userData.data.su_id);
//       const response = await DispatchCheckerService.eol_pass(modalData, userData.data.su_id);
//       ResponseMessage.success(response.message);
//       setTimeout(() => {
//         onAction('pass');
//         refreshCounts();
//         setIsPassProcessing(false);
//       }, 1500);
//     } catch (error) {
//       console.error(error);
//       ResponseMessage.error("Failed to process Pass request: " + (error.response?.data?.message || error.message));
//       setIsPassProcessing(false);
//     }
//   };

//   const handleClickReject = async () => {
//     try {
//       console.log(modalData, userData.data.su_id, prototypeForm);
//       const response = await DispatchCheckerService.eol_rejection(modalData, userData.data.su_id, prototypeForm);
//       ResponseMessage.success(response.message);
//       onAction('reject');
//       refreshCounts();
//     } catch (error) {
//       console.error(error);
//       ResponseMessage.error("Failed to process Reject request: " + (error.response?.data?.message || error.message));
//     }
//   };

//   const handleClickFail = async () => {
//     try {
//       const defects = displayedDataList.map(data => ({
//         op_type: parseInt(data.part),
//         op_id: parseInt(data.part),
//         def_id: parseInt(data.defect),
//         nos: parseInt(data.nos),
//         part_type: data.imageType,
//       }));

//       console.log("Fail action with defects:", defects);

//       const response = await DispatchCheckerService.eol_fail(
//         modalData,
//         userData.data.su_id,
//         prototypeForm,
//         imageType,
//         defects
//       );

//       ResponseMessage.success(response.message);
//       onAction('fail');
//       refreshCounts();
//     } catch (error) {
//       console.error(error);
//       ResponseMessage.error("Failed to process Fail request: " + (error.response?.data?.message || error.message));
//     }
//   };

//   const isPassDisabled = !isLineItemSelected || hasSaved || isPartFilled || isPassProcessing || isFormFullyComplete;
//   console.log("Pass button disabled:", isPassDisabled, {
//     isLineItemSelected,
//     hasSaved,
//     isPartFilled,
//     isPassProcessing,
//     isFormFullyComplete,
//   });

//   // Tooltip message for disabled Pass button
//   const passTooltip = isPassDisabled
//     ? !isLineItemSelected
//       ? "Please select both Line and Item"
//       : hasSaved
//       ? "Cannot pass after saving defects"
//       : isPartFilled
//       ? "Clear part selection to pass"
//       : isPassProcessing
//       ? "Pass request in progress"
//       : isFormFullyComplete
//       ? "Clear defect selection to pass"
//       : "Pass button disabled"
//     : "Click to mark as Pass";

//   return (
//     <div style={styles.container}>
//       <Row>
//         <Col span={24} style={{ marginBottom: "10px" }}>
//           <Tooltip title={passTooltip}>
//             <Button
//               size="large"
//               style={{ ...styles.button, backgroundColor: "green" }}
//               onClick={handleClickPass}
//               disabled={isPassDisabled}
//             >
//               <span style={styles.text}>PASS</span>
//               <span style={styles.emoji}>😊</span>
//             </Button>
//           </Tooltip>
//         </Col>
//         <Col span={24} style={{ marginBottom: "10px" }}>
//           <Button
//             size="large"
//             style={{ ...styles.button, backgroundColor: "orange" }}
//             onClick={handleClickFail}
//             disabled={!hasSaved}
//           >
//             <span style={styles.text}>FAIL</span>
//             <span style={styles.emoji}>🙁</span>
//           </Button>
//         </Col>
//         <Col span={24}>
//           <Button
//             size="large"
//             style={{ ...styles.button, backgroundColor: "red" }}
//             onClick={handleClickReject}
//             disabled={!hasSaved}
//           >
//             <span style={styles.text}>REJECT</span>
//             <span style={styles.emoji}>😢</span>
//           </Button>
//         </Col>
//       </Row>
//     </div>
//   );
// };

// export default ReviewButton;
import { Button, Row, Col, Tooltip } from "antd";
import DispatchCheckerService from "../../../services/Dispatch-Checker/DispatchCheckerService";
import ResponseMessage from "../../Comman/Notification/ResponseMessge";
import { useState } from "react";

const ReviewButton = ({
  prototypeForm,
  modalData,
  onAction,
  hasSaved,
  isFormComplete,
  imageType,
  displayedDataList,
  refreshCounts,
  isLineItemSelected,
  isPartFilled,
  isFormFullyComplete,
}) => {
  const [isPassProcessing, setIsPassProcessing] = useState(false);

  const styles = {
    button: {
      width: "100%",
      fontWeight: "bold",
      color: "white",
      height: "80px",
      lineHeight: "80px",
      fontSize: "30px",
      padding: "10px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      position: "relative",
      zIndex: 1,
    },
    text: { marginLeft: "25px" },
    emoji: { marginRight: "30px" },
    container: { position: "relative", zIndex: 1 },
  };

  const userData = JSON.parse(localStorage.getItem('userData'));

  const handleClickPass = async () => {
    setIsPassProcessing(true);
    try {
      console.log(modalData, userData.data.su_id);
      const response = await DispatchCheckerService.eol_pass(modalData, userData.data.su_id);
      ResponseMessage.success(response.message);
      setTimeout(() => {
        onAction('pass');
        refreshCounts();
        setIsPassProcessing(false);
      }, 1500);
    } catch (error) {
      console.error(error);
      ResponseMessage.error("Failed to process Pass request: " + (error.response?.data?.message || error.message));
      setIsPassProcessing(false);
    }
  };

  const handleClickReject = async () => {
    try {
      console.log(modalData, userData.data.su_id, prototypeForm);
      const response = await DispatchCheckerService.eol_rejection(modalData, userData.data.su_id, prototypeForm);
      ResponseMessage.success(response.message);
      onAction('reject');
      refreshCounts();
    } catch (error) {
      console.error(error);
      ResponseMessage.error("Failed to process Reject request: " + (error.response?.data?.message || error.message));
    }
  };

  const handleClickFail = async () => {
    try {
      const defects = displayedDataList.map(data => ({
        op_type: parseInt(data.part),
        op_id: parseInt(data.part),
        def_id: parseInt(data.defect),
        nos: parseInt(data.nos),
        part_type: data.imageType,
      }));

      console.log("Fail action with defects:", defects);

      const response = await DispatchCheckerService.eol_fail(
        modalData,
        userData.data.su_id,
        prototypeForm,
        imageType,
        defects
      );

      ResponseMessage.success(response.message);
      onAction('fail');
      refreshCounts();
    } catch (error) {
      console.error(error);
      ResponseMessage.error("Failed to process Fail request: " + (error.response?.data?.message || error.message));
    }
  };

  const isPassDisabled = !isLineItemSelected || hasSaved || isPartFilled || isPassProcessing || isFormFullyComplete;
  console.log("Pass button disabled:", isPassDisabled, {
    isLineItemSelected,
    hasSaved,
    isPartFilled,
    isPassProcessing,
    isFormFullyComplete,
  });

  const passTooltip = isPassDisabled
    ? !isLineItemSelected
      ? "Please select both Line and Item"
      : hasSaved
      ? "Cannot pass after saving defects"
      : isPartFilled
      ? "Clear part selection to pass"
      : isPassProcessing
      ? "Pass request in progress"
      : isFormFullyComplete
      ? "Clear defect selection to pass"
      : "Pass button disabled"
    : "Click to mark as Pass";

  return (
    <div style={styles.container}>
      <Row>
        <Col span={24} style={{ marginBottom: "10px" }}>
          <Tooltip title={passTooltip}>
            <Button
              size="large"
              style={{ ...styles.button, backgroundColor: "green" }}
              onClick={handleClickPass}
              disabled={isPassDisabled}
            >
              <span style={styles.text}>PASS</span>
              <span style={styles.emoji}>😊</span>
            </Button>
          </Tooltip>
        </Col>
        <Col span={24} style={{ marginBottom: "10px" }}>
          <Button
            size="large"
            style={{ ...styles.button, backgroundColor: "orange" }}
            onClick={handleClickFail}
            disabled={!hasSaved}
          >
            <span style={styles.text}>FAIL</span>
            <span style={styles.emoji}>🙁</span>
          </Button>
        </Col>
        <Col span={24}>
          <Button
            size="large"
            style={{ ...styles.button, backgroundColor: "red" }}
            onClick={handleClickReject}
            disabled={!hasSaved}
          >
            <span style={styles.text}>REJECT</span>
            <span style={styles.emoji}>😢</span>
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default ReviewButton;